module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAABPklEQVQokY3SMUtXYRQG8J8ZQuGQZGuLU5vQouAalZM4WC7KdTPu4BC30bk71NBFnbr8HSQcgpYK/QRubi0KfgAhiGhIJHnlFK//ruWZnvO8z3nu4Tl3QEfVTXsbexiL10NMVGVx3K++1mWAZ9mwwMtdwoG6aZ9jOON+Yg3v8DC4HTwJ46FM+/06TrDaZzyF+RhM9RRbeNynW0kGb/ALCxjHYAh7mAlhLxs+xT420fwJsW7alyhxM6j3+BL4HmYD/0iDVVm8OM8g36du2kf4hOMIbTue5rCO0bRJVRaff88M5ga7Hz8cPJieuYGNWPl+fOQbXuGoKouNC1foOk1s04tcUm1WZbHYpbvsP0h16xL8f4O6ae9iMqMmg7vyBq9xJ+sTTtyVDdKJDrI+4fOz9de/QhzB22iXqrL4+pcIZ8DORZyLgnDwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/specializations/leagueoflegends/support.png
// module id = pBop
// module chunks = 38